module.exports = __webpack_public_path__ + "static/img/logo.f74293b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.jpg
// module id = 4GjL
// module chunks = 6